import { intlFormat, setDefaultOptions } from 'date-fns';

import { LanguageKey } from '@pletly/common';
import { getDay, getYear, format, formatDistanceToNow, no, pl, en, es } from './date-fns';

function getFormattedWhen(timestamp?: number) {
	if (!timestamp) return '';

	const today = new Date();

	if (getDay(timestamp) === getDay(today)) {
		return format(timestamp, 'HH:mm aaa');
	}

	const localizedWithYear = intlFormat(timestamp, {
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
	});
	if (getYear(timestamp) === getYear(today)) {
		const dateWithoutYear = localizedWithYear.slice(0, -5);

		return dateWithoutYear;
	}

	return localizedWithYear;
}

const locales: Record<LanguageKey, Locale> = { en, no, pl, es } as const;

function getTimeToNow(time: number) {
	return formatDistanceToNow(time, { addSuffix: true });
}

function getFormattedTimestamp(date?: Date) {
	if (!date) return '';

	return date.toLocaleString();
}

function setLocale(language: LanguageKey) {
	return setDefaultOptions({ locale: locales[language] });
}

export { getFormattedWhen, getTimeToNow, format, getFormattedTimestamp, setLocale };
